import { first, flow, get, uniqBy } from 'lodash';
import { connect } from 'react-redux';
import Metrics from './Metrics';
import { createSelector } from 'reselect';
import { makeInsightsByTypeSelector } from 'store/state/domainData/selectors';
import { InsightDescriptor } from 'utils/entities';
import {
  PriceTrendByDealType,
  PriceTrendsNewSummary,
  ConnectivityInsightSummary,
} from 'store/state/selectors/insights/summaryTypes';
import { rtSymbolToColor } from 'store/state/selectors/insights/transportation/utils';

const LINES_LIMIT = 6;

const responseDataSelector = createSelector([
  flow(makeInsightsByTypeSelector(InsightDescriptor.PriceTrendsNew), first),
  flow(makeInsightsByTypeSelector(InsightDescriptor.Connectivity), first),
], (priceTrendsInsight, connectivityInsight) => {

  if (!(priceTrendsInsight || connectivityInsight)) {
    return {
      insightsData: {},
    };
  }

  const linesData = connectivityInsight
    ? (connectivityInsight.summary.nonText.data as ConnectivityInsightSummary).railStations
      .reduce((res, current) => {
        res = [ ...res, ...current.lines ];
        return res;
      }, [])
    : null;

  const subwayLines = linesData ? uniqBy(linesData, 'routeId').slice(0, LINES_LIMIT).map(l => ({
    color: l.routeColor ? `#${l.routeColor}` : rtSymbolToColor[l.routeName],
    label: l.routeName,
  })) : null;

  const { data: pricesData } = priceTrendsInsight.summary.nonText.data as PriceTrendsNewSummary;
  const [ topDataSource ] = get(pricesData, [ 'all', 'all' ])
    && get(pricesData, [ 'all', 'all' ]).slice().reverse() as PriceTrendByDealType[];

  return topDataSource ? {
    insightsData: {
      deals: topDataSource.dealsNumber,
      buy: topDataSource.buyPrice,
      rent: topDataSource.rentPrice,
      ppa: topDataSource.ppa,
      yield: topDataSource.yield,
      subwayLines,
      schoolsScore: null,
    },
  } : null;
});

export default connect(responseDataSelector)(Metrics);
